import { createCompoundComponent } from '../../utilities'

import { Swatches as RootSwatches } from './Swatches'
import { Item } from './Item'

export const Swatches = createCompoundComponent(RootSwatches, { Item })
